import styled from "styled-components";
import { colorsPalettes, fonts } from "@similarweb/styles";
import { setFont } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";

export const StyledSLModalContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
`;

export const StyledTitleContainer = styled.div`
    width: 100%;

    ${setFont({
        $size: 20,
        $weight: 500,
        $family: fonts.$dmSansFontFamily,
        $color: colorsPalettes.carbon[500],
    })};

    line-height: 24px;
`;
export const StyledDetailsContainer = styled.div`
    margin-bottom: 24px;
    width: 100%;

    ${setFont({
        $size: 16,
        $weight: "normal",
        $family: fonts.$robotoFontFamily,
        $color: colorsPalettes.carbon[400],
    })};

    line-height: 20px;
`;

export const StyledButtonContainer = styled.div`
    padding-top: 20px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
`;

export const StyledCancelBtn = styled(Button)`
    margin-right: 10px;
`;

export const StyledCheckboxContainer = styled.div`
    display: flex;
    width: 100%;
`;
